import { IError } from "src/common/types";

export const mapError = ({ code }: IError) => (code ? code : undefined);
